import { createContext } from 'react';
import { AccessCheckElementAccess } from '../constants/accessCheckElementAccess';
export const AccessCheckAccessInfoContext = /*#__PURE__*/createContext({
  hasAccess: false,
  isVisible: false,
  missingSeats: [],
  missingPermissions: [],
  missingScopes: [],
  requireAllPermissions: false,
  status: AccessCheckElementAccess.LOADING,
  isLoading: false
});